import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getSubscriptionUserInfo, getUserInfo } from "../utils/utils";
import moment from "moment";
import { getToken } from "../utils/auth";
import { subscriptionPlans, utmSource } from "../config";
import { useAlert } from "../context/AlertProvider";

const RouteGuard = ({ children }) => {
  const user = getUserInfo();
  const subscription = getSubscriptionUserInfo();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const source = searchParams.get(utmSource);

  useEffect(() => {
    if (source) {
      sessionStorage.setItem(utmSource, source);
    }
  }, [source]);

  useEffect(() => {
    const inputDateTime = moment(subscription?.validTo); // Replace with your date
    const now = moment();
    function maintainSourceType() {
      const storedSourceType = sessionStorage.getItem(utmSource);
      if (!storedSourceType) return;

      const params = new URLSearchParams(window.location.search);
      if (!params.has(utmSource)) {
        params.set(utmSource, storedSourceType);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
      }
    }

    maintainSourceType();

    if (
      user?.passwordChangeNeeded &&
      location.pathname !== "/account/change-password"
    ) {
      navigate("/account/change-password");
    }

    if (
      !!getToken() &&
      inputDateTime.isBefore(now) &&
      location.pathname !== "/account/subscription-expired" &&
      location.pathname !== "/my-account" &&
      location.pathname !== "/pricing" &&
      location.pathname !== "/checkout"
    ) {
      navigate("/account/subscription-expired");
    }

    if (
      subscription?.subscriptionPackage?.name !== subscriptionPlans?.trail &&
      !inputDateTime.isBefore(now) &&
      location.pathname === "/checkout"
    ) {
      navigate("/dashboard-view");
      showAlert(
        "warning",
        "You already have an active subscription. You can subscribe again once it expires."
      );
    }
  }, [user, location, navigate, subscription]);

  return children;
};

export default RouteGuard;
